import { render, staticRenderFns } from "./LeftQuestionForm.vue?vue&type=template&id=5f502b19&scoped=true&"
import script from "./LeftQuestionForm.vue?vue&type=script&lang=js&"
export * from "./LeftQuestionForm.vue?vue&type=script&lang=js&"
import style0 from "./LeftQuestionForm.vue?vue&type=style&index=0&id=5f502b19&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f502b19",
  null
  
)

export default component.exports